import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import flag8 from "../../../assets/images/flag8.png";
import TextField from "@material-ui/core/TextField";
import flag_bd4 from "../../../assets/images/flag_bd4.png";
import flag_usa4 from "../../../assets/images/flag_usa4.png";
import { TransferContext } from "../../../context/TransferContext";

const useStyles = makeStyles(() => ({
  marginBottomStyle: {
    marginBottom: "10px",
  },

  inputStyle: {
    borderRadius: "8px",
  },
  inputStyle2: {
    borderRadius: "8px",
    // "& .MuiInputBase-input": {
    //   color: "#A2A2A2",
    // },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      fontSize: "14px",
      padding: 13,
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
  },
  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 13,
    },
  },
  selectStyle: {
    textAlign: "left",

    "& img": {
      position: "relative",
      top: "2px",
      marginRight: "5px",
    },
  },
  selectItemStyle: {
    fontWeight: 600,
  },
  muteColor: {
    color: "#19181666",
  },
  inputRoot: {
    "& .MuiOutlinedInput-input": {
      // color: "green",
      // fontWeight: 600,
    },
    "& .MuiInputLabel-root": {
      // color: "green",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "#eee",
      // backgroundColor: "#eee",
      color: "#333",
    },
    "&:hover .MuiOutlinedInput-input": {
      // color: "red",
    },
    "&:hover .MuiInputLabel-root": {
      // color: "red",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      // color: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      // color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      // borderColor: "purple",
    },
  },
  flag: {
    marginRight: 10,
    width: 20,
    position: "relative",
    top: 4,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
      borderWidth: 0,
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 8,
  },
  file_button: {
    textTransform: "capitalize",
    color: "#999",
  },
}));
const ReceiverDetails = () => {
  const classes = useStyles();
  const { transfer, addToTransfer } = useContext(TransferContext);

  const [documentType, setDocumentType] = useState(5);

  const [name, setName] = useState(transfer.r_name);
  const [documentId, setDocumentId] = useState(transfer.r_documentId);
  const [documentNumber, setDocumentNumber] = useState(
    transfer.r_documentNumber
  );
  const [mobileNumber, setMobileNumber] = useState(transfer.r_phone);
  const [phoneCode, setPhoneCode] = useState(
    transfer.toCountry && transfer.toCountry.code
  );
  const [flag, setFlag] = useState(
    transfer.toCountry && transfer.toCountry.flag
  );

  const [phone, setPhone] = useState(transfer.toCountry && transfer.toCountry.phone);


  const handleName = (e) => {
    setName(e.target.value);
    addToTransfer({ r_name: e.target.value });
  };

  const handleDocumentId = (e) => {
    setDocumentId(e.target.value);
    addToTransfer({ r_documentId: e.target.value });
  };

  const handleDocumentNumber = (e) => {
    setDocumentNumber(e.target.value);
    addToTransfer({ r_documentNumber: e.target.value });
  };

  const HandleMobileNumber = (e) => {
    setMobileNumber(e.target.value);
    addToTransfer({ r_phone: e.target.value });
    addToTransfer({ r_mobileNumber: `${phone}${e.target.value}` });
  };

  const handlePhoneCode = (e) => {

    let value = e.target.value;
    let myValue = transfer.countries.filter((event) => event.code === value);
    console.log("new", myValue);
    setPhoneCode(myValue[0].code);
    setPhone(myValue[0].phone);

    // setPhoneCode(e.target.value);
    addToTransfer({ r_phoneCode: myValue[0].phone });
    addToTransfer({ r_mobileNumber: `${myValue[0].phone}${mobileNumber}` });


    
  };

  return (
    <>
      {/* <Typography variant="h4" className={classes.marginBottomStyle}>
        Sender Details
      </Typography> */}
      <Grid container alignItems="center" spacing={3}>
        <Grid item xs={3}>
          <Typography variant="body1">Name</Typography>
        </Grid>
        <Grid item xs={9}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                id="first-name"
                size="small"
                fullWidth
                placeholder="Name"
                variant="outlined"
                className={classes.textField}
                value={name}
                onChange={handleName}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body1">Document Type</Typography>
        </Grid>

        <Grid item xs={9}>
          <FormControl variant="outlined" size="small" fullWidth>
            <Select
              labelId="document-select-outlined-label"
              id="document-select-outlined"
              className={classes.inputStyle2}
              defaultValue="na"
              value={documentId}
              onChange={handleDocumentId}
            >
              <MenuItem disabled value="na">
                <span style={{ color: "#999" }}>Select One</span>
              </MenuItem>
              {transfer.documents.map((item, index) => (
                <MenuItem value={item.id} key={index}>
                  {item.documentType}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1">Document Number</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            id="nid"
            size="small"
            fullWidth
            placeholder="Enter Id/Number"
            variant="outlined"
            className={classes.textField}
            value={documentNumber}
            onChange={handleDocumentNumber}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body1">Mobile Number</Typography>
        </Grid>

        <Grid item xs={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            fullWidth
          >
            <TextField
              className={classes.inputRoot}
              displayEmpty
              defaultValue="na"
              value={phoneCode}
              onChange={handlePhoneCode}
              variant="outlined"
              select
              // disabled
              InputProps={{
                className: classes.select,
              }}
              size="small"
            >
              <MenuItem value="na" disabled>
                <span style={{ color: "#999" }}>Select code</span>
              </MenuItem>
              {transfer.countries.map((item, index) => (
                <MenuItem value={item.code} key={index}>
                  <img src={item.flag} alt="" className={classes.flag} />
                  {item.phone}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>
        <Grid item xs={7}>
          <TextField
            id="number"
            size="small"
            fullWidth
            variant="outlined"
            placeholder="Enter Mobile Number"
            className={classes.textField}
            value={mobileNumber}
            onChange={HandleMobileNumber}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ReceiverDetails;
